import { Component, OnInit } from '@angular/core';
import { CaseFilesListComponent } from '@app/modules/case/components/case-files-list/case-files-list.component';
import { ContentStoreService } from '@app/core/services/content-store.service';
import { FileUtilityService } from '@app/core/services/file-utility.service';
import { AuthenticationService } from '@app/core/authentication';
import { FileActions } from '@app/shared/models/file-actions';

@Component({
  selector: 'case-files-thumbnails-list',
  templateUrl: './case-files-thumbnails-list.component.html',
  styleUrls: ['./case-files-thumbnails-list.component.scss']
})
export class CaseFilesThumbnailsListComponent extends CaseFilesListComponent implements OnInit {

  constructor(protected contentStoreService: ContentStoreService,
              protected fileUtilityService: FileUtilityService,
              protected authenticationService: AuthenticationService) {
    super(contentStoreService, fileUtilityService, authenticationService);
  }

  ngOnInit() {
    this.disabledOptions = [FileActions.LABEL];
  }

}
